import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import { AppletEventContainerModel } from '../../../../../models/aggregates/applet/applet-event-container.model';

@Injectable({
  providedIn: 'root'
})
export class TenantAppletEventService extends BaseApiTemplateService<AppletEventContainerModel> {
  protected apiUrl: string;

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'applet-events/backoffice-ep';
    this.httpClient = http;
  }
}
